import { MultiLevelCategory, ProductBaseInfo } from '@shopby/shop-sdk'
import { MouseEvent, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { PropsType } from '../../@types/etc'
import { SectionDetailType } from '../../@types/home'
import { getCategorySearch, getSectionsDetail } from '../../api/home'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { errorBgImg } from '../../js/script'
import { BtnHomeModuleMore } from '../Button'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import { BrandRecommendItem } from './BrandRecommendItem'

export default function BrandRecommend({ el, index, homeModule, category }: PropsType) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>() // 섹션 아이템
  const [brandArray, setBrandArray] = useState<(MultiLevelCategory | undefined)[]>([]) //브랜드 배열
  const [selectBrand, setSelectBrand] = useState<number>(0) //선택된 브랜드
  const [items, setItems] = useState<ProductBaseInfo[]>([]) //카테고리로 조회
  const [like, setLike] = useState<boolean>(false) //좋아요 눌렀을때 상태 변경
  const [selectProductNo, setSelectProductNo] = useState<string>('') // 선택한 상품 번호
  const [isModal, setIsModal] = useState<boolean>(false)
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  //상품진열 디테일
  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [])

  // 브랜드만 가져오기
  useEffect(() => {
    if (category) {
      const brandArray = category?.multiLevelCategories
        ?.filter((el) => el.label === '브랜드')
        .flatMap((el) => el.children)
      if (brandArray !== undefined) {
        setBrandArray(brandArray || [])
      }
    }
  }, [category])

  //selectBrand 지정하기
  useEffect(() => {
    if (brandArray) {
      setSelectBrand(brandArray[0]?.categoryNo || 0)
    }
  }, [brandArray])
  //상품조회
  useEffect(() => {
    if (selectBrand) {
      getCategorySearch('MD_RECOMMEND', 1, Number(selectBrand), isMobile ? 6 : 8)
        .then((res) => {
          setItems(res.data.items)
        })
        .catch((err) => console.log(err))
    }
  }, [selectBrand, like])
  // 선택한 브랜드 넘버 넣기
  const handleClick = (categoryNo: any) => {
    setSelectBrand(categoryNo)
  }
  //터치감지
  const [isTouchMoving, setIsTouchMoving] = useState(false)
  //아이폰에서 스와이프 잘못눌리는거 방지
  const touchMove = () => {
    setIsTouchMoving(true)
  }
  //아이폰에서 스와이프 잘못눌리는거 방지
  const touchEnd = () => {
    setIsTouchMoving(false)
  }
  //아이폰에서 스와이프 잘못눌리는거 방지
  const handleTouchEnd = (categoryNo: any) => {
    if (!isTouchMoving) {
      setSelectBrand(categoryNo)
    }
  }

  return (
    <>
      <div
        className='brand_recommand'
        style={{ minHeight: isMobile ? '881px' : '1337px' }}
        onClick={(): void => {
          const gtmNavigateClick: DataLayerArgs = {
            dataLayer: {
              event: 'select_content',
              event_info: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            },
          }
          if (isAppView) {
            sendSetAppsflyerEvent({
              eventName: 'select_content',
              eventType: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            })
          } else {
            TagManager.dataLayer(gtmNavigateClick)
          }
        }}
      >
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain}</strong>
          </p>
        </div>
        <div className='brand_logo_wrap'>
          <SwiperWrap
            observer={true}
            observeParents={true}
            parallax={true}
            slidesPerView={'auto'}
            spaceBetween={10}
            breakpoints={{
              768: {
                spaceBetween: 16,
              },
            }}
            modules={[FreeMode]}
            freeMode={false}
            centeredSlidesBounds={true}
            slideToClickedSlide={true}
            onTouchMove={touchMove}
            onTouchEnd={touchEnd}
          >
            {brandArray.map((el: any): JSX.Element => {
              return (
                <SwiperSlideItem
                  className={el.categoryNo === selectBrand ? 'on' : ''}
                  key={el.categoryNo}
                  onTouchEnd={() => {
                    if (isMobile) handleTouchEnd(el.categoryNo)
                  }}
                  onClick={(): void => {
                    if (!isMobile) handleClick(el.categoryNo)
                  }}
                >
                  <a
                    href='#'
                    onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
                      e.preventDefault()
                    }}
                  >
                    <div
                      className='item_img'
                      style={{
                        backgroundImage: `url(${el.icon ? el.icon : errorBgImg})`,
                        backgroundSize: el.icon ? `cover` : `36px 36px`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div>
                    <p>{el.label}</p>
                  </a>
                </SwiperSlideItem>
              )
            })}
          </SwiperWrap>
        </div>
        <div className='brand_recommand_list'>
          <ul>
            {items.map((elment: any, idx: number): JSX.Element => {
              return (
                <BrandRecommendItem
                  key={`${elment.productNo}-${idx}`}
                  el={elment}
                  setLike={setLike}
                  setSelectProductNo={setSelectProductNo}
                  setIsModal={setIsModal}
                  idx={idx}
                  category={category}
                  selectBrand={selectBrand}
                  listId={el.sectionNo}
                  listName={el.sectionName}
                ></BrandRecommendItem>
              )
            })}
          </ul>
        </div>
        <div className='btn_more_wrap'>
          <BtnHomeModuleMore
            onClick={(): void => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/category/${selectBrand}/${selectBrand}/${selectBrand}`,
                })
              } else {
                navigate(`/category/${selectBrand}/${selectBrand}/${selectBrand}`)
              }
            }}
          >
            더보기
          </BtnHomeModuleMore>
        </div>
        {index !== 0 && <hr />}
      </div>
      {isModal &&
        (isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={items}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={items}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductCenterModal>
        ))}
    </>
  )
}

export const SwiperWrap = styled(Swiper)`
  padding: 0 18px;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    padding: 0;
    margin-bottom: 32px;
  }
`
export const SwiperSlideItem = styled(SwiperSlide)`
  width: auto !important;
  text-align: center;
  & a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  & .item_img {
    width: 57px;
    height: 57px;
    background-position: center;
    background-size: contain;
    box-shadow: 0px 0px 0px 1px var(--colGray3) inset;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
  }

  &.on {
    & .item_img {
      width: 57px;
      height: 57px;
      box-shadow: 0px 0px 0px 2px var(--colBlack) inset;
      border: none;
    }
    & p {
      color: var(--colBlack);
    }
  }

  & p {
    max-width: 57px;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    color: var(--colGray6);
    margin-top: 8px;
    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @media screen and (min-width: 768px) {
    & .item_img {
      align-items: center;
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: contain;
      border: none;
      border-radius: 50%;
      box-shadow: 0 0 0 1px var(--colGray3) inset;
      display: flex;
      height: 100px;
      justify-content: center;
      width: 100px;
    }

    &.on {
      & .item_img {
        order: none;
        border-radius: 50%;
        box-shadow: 0 0 0 2px var(--colBlack) inset;
        height: 100px;
        width: 100px;
      }
      & p {
        color: var(--colBlack);
      }
    }

    & p {
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      margin-top: 12px;
      max-width: 100px;
    }
  }
`
